export type TaxResidencyInputsArgs = {
  taxResidencies: Array<string>;
  tins: Record<string, Array<string>>;
};

const initForm = (el: Element) => {
  const data = el.getAttribute("data-tax-residency-inputs");
  if (!data) {
    console.error("No data found for tax residency form");
    return;
  }

  const taxData = JSON.parse(data) as TaxResidencyInputsArgs;

  const taxContainer = document.getElementById("tax-residency-container") as HTMLElement;
  const taxTemplate = document.getElementById("tax-residency-template") as HTMLTemplateElement;
  const tinContainer = document.getElementById("tin-container") as HTMLElement;
  const tinTemplate = document.getElementById("tin-template") as HTMLTemplateElement;
  const usCitizenSelect = document.getElementById("us-citizen-select") as HTMLSelectElement;
  const addTaxResidencyButton = document.getElementById("additional-tax-residency") as HTMLButtonElement;

  const taxResidencies: Array<HTMLElement> = [];
  const tins: Record<string, HTMLElement> = {};

  if (!taxContainer || !taxTemplate || !tinContainer || !tinTemplate || !usCitizenSelect || !addTaxResidencyButton) {
    console.error("Missing required elements on tax residency form");
    return;
  }

  function getTaxResidencyValues() {
    const selects = taxContainer.querySelectorAll('[name="taxResidencies[]"]');
    const values = [];
    for (const select of selects) {
      const value = (select as HTMLSelectElement).value;
      values.push(value);
    }
    return values;
  }

  function appendTaxResidencyInput(code: string) {
    const fragment = taxTemplate.content.firstElementChild?.cloneNode(true) as HTMLElement;
    const select = fragment.querySelector("select") as HTMLSelectElement;
    select.name = `taxResidencies[]`;
    select.value = code;
    const removeButton = fragment.querySelector("button") as HTMLButtonElement | null;
    if (removeButton) {
      removeButton.addEventListener("click", function (event) {
        event.preventDefault();
        fragment.remove();
        const index = taxResidencies.indexOf(fragment);
        if (index > -1) {
          taxResidencies.splice(index, 1);
        }
        sync();
      });
    }
    taxContainer.appendChild(fragment);
    taxResidencies.push(fragment);
  }

  function appendTinInput(code: string, value: string) {
    if (!!tins[code]) {
      return;
    }

    const fragment = tinTemplate.content.firstElementChild?.cloneNode(true) as HTMLElement;
    const input = fragment.querySelector("input") as HTMLInputElement;
    input.name = `tins[${code}][]`;
    input.dataset.code = code;
    input.value = value;
    const label = fragment.querySelector("label") as HTMLLabelElement;
    label.textContent = `Tax ID for ${code}`;
    tinContainer.appendChild(fragment);
    tins[code] = fragment;
  }

  function init() {
    if (taxData.taxResidencies.length === 0) {
      appendTaxResidencyInput("");
    } else {
      for (const value of taxData.taxResidencies) {
        appendTaxResidencyInput(value);
      }
    }

    for (const [code, values] of Object.entries(taxData.tins)) {
      const value = values[0];
      if (value) {
        appendTinInput(code, value);
      }
    }

    sync();
  }

  function sync() {
    const values = getTaxResidencyValues();
    const requiredCodes = new Set(values);
    let usAdded = false;
    for (const value of requiredCodes) {
      if (value === "" || value === "GB") {
        // uk tax id not required
        continue;
      }

      appendTinInput(value, "");

      if (value === "US") {
        usAdded = true;
      }
    }

    const isUsCitizen = usCitizenSelect.value === "true";
    if (isUsCitizen && !usAdded) {
      appendTinInput("US", "");
      requiredCodes.add("US");
    }

    for (const code of Object.keys(tins)) {
      if (!requiredCodes.has(code)) {
        tins[code].remove();
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete tins[code];
      }
    }
  }

  document.addEventListener("change", function (e) {
    if (!e.target) {
      return;
    }

    // @ts-expect-error ...
    if (e.target.name === "taxResidencies[]" || e.target.name === "usCitizen") {
      sync();
    }
  });

  addTaxResidencyButton.addEventListener("click", function () {
    appendTaxResidencyInput("");
  });

  init();
};

const el = document.currentScript;
if (el) {
  initForm(el);
}
